import { format } from 'date-fns';

export function WeekHeader({ date }) {
  const dayNumber = format(date, 'd');
  const dayName = format(date, 'EEE').toUpperCase();
  
  return (
    <div className="text-center">
      <span>{dayName} {dayNumber}</span>
    </div>
  );
}